/* eslint-disable no-nested-ternary */
/* eslint-disable */
import React, { useState, useEffect } from "react";

import { Popover, Skeleton, Tooltip } from "@mui/material";
import * as IconsSVG from "../../../../assets/iconsSVG";
import * as Styles from "../../styles";
import { CardTarefas } from "../cardTarefas";
import DialogCommon from "../../../../components/dialogCommon";
import NewTaskForm from "../../../../components/dialogCommon/templates/newTaskForm";
import EditTaskForm from "../../../../components/dialogCommon/templates/editTaskForm";
import ConcludeTaskForm from "../../../../components/dialogCommon/templates/concludeTaskForm";
import axiosLead from "../../../../services/lead";
import warn from "../../../../constants/toast";
import NewTaskV2 from "components/dialogCommon/templates/NewTaskV2";
import * as StylesF from "screens/lead/components/cardOportunidades/styles";
import MaterialUI from "../../../../material-UI";
import { ptBR } from "date-fns/locale";
import ToggleBtns from "components/toggleBtns";
import { useTransformList } from "hooks/objectToLabelValue";
import { useTiposTarefas } from "services/api/AppWeb_Lead";

const SectionTasks = (props: any) => {
  const [newTask, setNewTask] = useState<boolean>(false);
  const [tabValue, setTabValue] = useState<number>(0);
  const [tasks, setTasks] = useState([]);
  const [lateTasks, setLateTasks] = useState<any>([]);
  const [loadingTasks, setLoadingTasks] = useState<boolean>(false);
  const [editTask, setEditTask] = useState<boolean>(false);
  const [concludeTask, setConcludeTask] = useState<boolean>(false);
  const [itemTask, setItemTask] = useState<any>({});
  const [itemConclude, setItemConclude] = useState<any>({});
  const [todayTasksCount, setTodayTasksCount] = useState<number>(0);
  const [lateTasksCount, setLateTasksCount] = useState<number>(0);
  const [totalRetornoToday, setTotalRetornoToday] = useState<number>(9999);
  const [totalRetornoLate, setTotalRetornoLate] = useState<number>(9999);
  // Atrasadas
  const [paginaAtualAtrasadas, setPaginaAtualAtrasadas] = useState(1);
  const [qtdPaginasAtrasadas, setqtdPaginasAtrasadas] = useState(0);
  const [loadAtrasadas, setLoadAtradas] = useState(false);
  const [totalItemsAtrasadas, setTotalItemsAtrasadas] = useState(0);
  // Hoje
  const [paginaAtualHoje, setPaginaAtualHoje] = useState(1);
  const [qtdPaginasHoje, setqtdPaginasHoje] = useState(0);
  const [loadHoje, setLoadHoje] = useState(false);
  const [totalItemsHoje, setTotalItemsHoje] = useState(0);
  const [renderTab, setRenderTab] = useState(false);
  // Filtros
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const [taskFilter, setTaskFilter] = React.useState<{
    InicioIntervaloCadastroTarefa: string | null;
    FimIntervaloCadastroTarefa: string | null;
    idsTiposTarefa: string[] | null;
  }>({
    InicioIntervaloCadastroTarefa: null,
    FimIntervaloCadastroTarefa: null,
    idsTiposTarefa: null,
  });

  const {
    data: dataTiposTarefas,
    refetch: refetchTiposTarefas,
    isFetching: isFetchingTiposTarefas,
  } = useTiposTarefas({
    queryKey: "tipos-tarefas-filtros",
  });

  useEffect(() => {
    setLoadingTasks(true);
    requestTasks();
    requestTasksLate(1);
  }, []);

  const requestTasks = async () => {
    setLoadingTasks(true);
    try {
      const response = await axiosLead.GetTasksOfDay(
        totalRetornoToday,
        taskFilter.idsTiposTarefa,
        taskFilter.InicioIntervaloCadastroTarefa,
        taskFilter.FimIntervaloCadastroTarefa
      );
      setTodayTasksCount(response.data.data.length);
      setTasks(response.data.data);
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar tarefas do dia"
      );
    }
    setLoadingTasks(false);
  };

  const requestTasksLate = async (page: number) => {
    if (page === 1) {
      setLateTasks([]);
    }
    try {
      const response: any = await axiosLead.GetLateTasks(
        page,
        10,
        taskFilter.idsTiposTarefa,
        taskFilter.InicioIntervaloCadastroTarefa,
        taskFilter.FimIntervaloCadastroTarefa
      );
      // setLateTasksCount(response.data.data.length);
      let ArrayData = lateTasks;
      response.data.data.forEach((item: any) => {
        let itemExistente = lateTasks.find(
          (obj: any) => obj.idTarefaLead === item.idTarefaLead
        );
        if (!itemExistente) {
          ArrayData.push(item);
        }
      });
      if (page !== 1) {
        setLateTasks(ArrayData);
      } else {
        setLateTasks(response.data.data);
      }

      //setLateTasks([...lateTasks, ...response?.data?.data]);
      setPaginaAtualAtrasadas(response.data.pagination.currentPage);
      setqtdPaginasAtrasadas(response.data.pagination.quantityPages);
      setTotalItemsAtrasadas(response.data.pagination.totalItems);
      setLoadingTasks(false);
    } catch (error: any) {
      console.log("Erro ao listar tarefas atrasadas");
    }
    setLoadingTasks(false);
  };

  const handleScrollToday = (e: any) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      if (qtdPaginasAtrasadas === paginaAtualAtrasadas) {
        return;
      } else {
        setTotalRetornoToday(totalRetornoToday + 10);
      }
    }
  };

  useEffect(() => {
    if (renderTab) {
      requestTasksLate(1);
    }
  }, [tabValue, renderTab]);

  const recuperarTab = async () => {
    const chaveLocalStorage = "@TaskTab";
    const tab = await localStorage.getItem(chaveLocalStorage);
    if (tab) {
      setTabValue(parseInt(tab, 10));
      setRenderTab(true);
    } else {
      setTabValue(0);
      setRenderTab(true);
    }
  };

  useEffect(() => {
    recuperarTab();
  }, []);

  const handleChange = (newValue: any) => {
    setTabValue(newValue);
    localStorage.setItem("@TaskTab", newValue.toString());
  };

  const handleScrollLate = (e: any) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      if (qtdPaginasAtrasadas === paginaAtualAtrasadas) {
        return;
      } else {
        requestTasksLate(paginaAtualAtrasadas + 1);
      }
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    refetchTiposTarefas();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClearFilter = () => {
    setTaskFilter({
      InicioIntervaloCadastroTarefa: null,
      FimIntervaloCadastroTarefa: null,
      idsTiposTarefa: null,
    });
  };

  const handleAplicarFiltros = () => {
    setLateTasks([]);
    requestTasksLate(1);
    setTasks([]);
    requestTasks();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const transformedTiposTarefas = useTransformList({
    inputList: dataTiposTarefas?.data,
    labelField: "nome",
    valueField: "id",
  });

  return (
    <Styles.SectionTasks>
      <Styles.HeaderTasks>
        <Styles.Row>
          <IconsSVG.NewTaskDialog />
          <Styles.TasksTitle>Minhas Tarefas</Styles.TasksTitle>
        </Styles.Row>
        <Tooltip title="Criar tarefa" placement="top" followCursor arrow>
          <Styles.Button
            className="plus-btn"
            onClick={() => setNewTask(!newTask)}
          >
            <IconsSVG.PlusWhite />
          </Styles.Button>
        </Tooltip>
        <StylesF.ButtonTarefas
          style={{ width: "50px", marginLeft: 8 }}
          isSelected={false}
          onClick={handleClick}
        >
          <IconsSVG.FilterIconBlue />
        </StylesF.ButtonTarefas>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <StylesF.ModalContent>
            <StylesF.HeaderModal>
              <IconsSVG.FilterModalIcon />
              <StylesF.HeaderModalTitle>Filtros</StylesF.HeaderModalTitle>
              <StylesF.ClearBtn onClick={handleClearFilter}>
                Limpar
              </StylesF.ClearBtn>
            </StylesF.HeaderModal>
            <div style={{ marginTop: 16 }}>
              <StylesF.LabelModal>Período</StylesF.LabelModal>
              <StylesF.LocalizationProvider
                locale={ptBR}
                dateAdapter={MaterialUI.AdapterDateFns}
              >
                <StylesF.Row>
                  <StylesF.ContentDate>
                    <StylesF.DesktopDatePicker
                      inputFormat="dd/MM/yyyy"
                      value={taskFilter?.InicioIntervaloCadastroTarefa}
                      components={{
                        OpenPickerIcon: IconsSVG.CalendarIcon,
                      }}
                      disabled={false}
                      InputAdornmentProps={{ position: "start" }}
                      onChange={(newValue: any) =>
                        setTaskFilter({
                          ...taskFilter,
                          InicioIntervaloCadastroTarefa: newValue,
                        })
                      }
                      renderInput={(params: any) => (
                        <>
                          <StylesF.LabelText>De</StylesF.LabelText>
                          <StylesF.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="De"
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </StylesF.ContentDate>
                  <StylesF.ContentDate>
                    <StylesF.DesktopDatePicker
                      inputFormat="dd/MM/yyyy"
                      value={taskFilter?.FimIntervaloCadastroTarefa}
                      disabled={false}
                      components={{
                        OpenPickerIcon: IconsSVG.CalendarIcon,
                      }}
                      InputAdornmentProps={{ position: "start" }}
                      onChange={(newValue: any) =>
                        setTaskFilter({
                          ...taskFilter,
                          FimIntervaloCadastroTarefa: newValue,
                        })
                      }
                      minDate={taskFilter?.InicioIntervaloCadastroTarefa}
                      renderInput={(params: any) => (
                        <>
                          <StylesF.LabelText>Até</StylesF.LabelText>
                          <StylesF.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Até"
                            fullWidth
                            error={false}
                            helperText={""}
                          />
                        </>
                      )}
                    />
                  </StylesF.ContentDate>
                </StylesF.Row>
              </StylesF.LocalizationProvider>
            </div>
            <div style={{ marginTop: 16 }}>
              <StylesF.LabelModal>Tipo de tarefa</StylesF.LabelModal>
              {isFetchingTiposTarefas ? (
                <>
                  <Skeleton variant="rounded" width="350px" height="75px" />
                </>
              ) : (
                <>
                  <ToggleBtns
                    data={transformedTiposTarefas}
                    value={taskFilter?.idsTiposTarefa}
                    onChange={(newValues: any) => {
                      setTaskFilter({
                        ...taskFilter,
                        idsTiposTarefa: newValues,
                      });
                    }}
                  />
                </>
              )}
            </div>
            <StylesF.FooterModal>
              <StylesF.ButtonModal onClick={handleAplicarFiltros}>
                Aplicar filtro
              </StylesF.ButtonModal>
            </StylesF.FooterModal>
          </StylesF.ModalContent>
        </Popover>
      </Styles.HeaderTasks>
      {renderTab ? (
        <Styles.Row>
          <Styles.FilterTasks
            className={tabValue === 0 ? "filter-active" : "filter-left"}
            onClick={() => {
              handleChange(0);
              requestTasks();
              setLateTasks([]);
            }}
          >
            Para hoje ({todayTasksCount})
          </Styles.FilterTasks>
          <Styles.FilterTasks
            className={tabValue === 1 ? "filter-active" : "filter-right"}
            onClick={() => {
              handleChange(1);
              requestTasksLate(1);
            }}
          >
            Atrasadas ({totalItemsAtrasadas})
          </Styles.FilterTasks>
        </Styles.Row>
      ) : null}

      {tabValue === 0 ? (
        <Styles.ContentTarefas>
          {loadingTasks ? (
            <Styles.LoadingTasks />
          ) : tasks && tasks.length > 0 ? (
            tasks.map((item: any) => (
              <CardTarefas
                key={item.idTarefaLead}
                title={item.titulo}
                lead={item.nomeLead}
                tipoTarefa={item.tipoTarefa}
                statusTarefa={item.descricaoStatusTarefa}
                data={item.dataHoraProgramadaRealizacaoTarefa}
                dataCriacaoTarefa={item?.dataCriacaoTarefa}
                dataConclusao={item.dataHoraConclusaoTarefa}
                obs={item.observacao}
                tipoConclusao={item.tipoResultadoTarefa}
                etapa={item.descricaoEtapaFunilLead}
                setEditTask={setEditTask}
                editTask={editTask}
                urlAnexo={item.urlAnexo}
                onItemEdit={() => setItemTask(item)}
                setConcludeTask={setConcludeTask}
                concludeTask={concludeTask}
                onItemConclude={() => setItemConclude(item)}
                descricao={item.descricao}
                empreendimento={item.empreendimento}
                tipoResultadoTarefa={item.tipoResultadoTarefa}
                idLeadCorretor={item.idLeadCorretor}
                telefonePrincipal={item.telefonePrincipal}
                emailPrincipal={item.emailPrincipal}
              />
            ))
          ) : (
            <Styles.Text
              style={{
                textAlign: "center",
                marginTop: 40,
                paddingBottom: 40,
              }}
            >
              Sem tarefas para hoje
            </Styles.Text>
          )}
        </Styles.ContentTarefas>
      ) : (
        <Styles.ContentTarefas onScroll={(e) => handleScrollLate(e)}>
          {loadingTasks ? (
            <Styles.LoadingTasks />
          ) : lateTasks && lateTasks.length > 0 ? (
            lateTasks.map((item: any) => (
              <CardTarefas
                key={item.idTarefaLead}
                title={item.titulo}
                lead={item.nomeLead}
                tipoTarefa={item.tipoTarefa}
                statusTarefa={item.descricaoStatusTarefa}
                data={item.dataHoraProgramadaRealizacaoTarefa}
                dataCriacaoTarefa={item?.dataCriacaoTarefa}
                dataConclusao={item.dataHoraConclusaoTarefa}
                obs={item.observacao}
                tipoConclusao={item.tipoResultadoTarefa}
                etapa={item.descricaoEtapaFunilLead}
                setEditTask={setEditTask}
                editTask={editTask}
                urlAnexo={item.urlAnexo}
                onItemEdit={() => setItemTask(item)}
                setConcludeTask={setConcludeTask}
                concludeTask={concludeTask}
                onItemConclude={() => setItemConclude(item)}
                descricao={item.descricao}
                empreendimento={item.empreendimento}
                tipoResultadoTarefa={item.tipoResultadoTarefa}
                idLeadCorretor={item.idLeadCorretor}
                telefonePrincipal={item.telefonePrincipal}
                emailPrincipal={item.emailPrincipal}
              />
            ))
          ) : (
            <Styles.Text
              style={{
                textAlign: "center",
                marginTop: 40,
                paddingBottom: 40,
              }}
            >
              Sem tarefas atrasadas
            </Styles.Text>
          )}
        </Styles.ContentTarefas>
      )}
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setNewTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        titleHeader="Agendar tarefa"
        isFilter={false}
        isClose
        width={500}
        maxHeight="680px"
        component={
          // <NewTaskForm
          //   idLead=""
          //   idLeadCorretor=""
          //   nomeLead=""
          //   onClose={setNewTask}
          //   open={newTask}
          //   hotRefreshFunc={() => {
          //     requestTasks();
          //     requestTasksLate(1);
          //   }}
          //   isHome
          //   setItemConclude={setItemConclude}
          //   setConcludeTask={setConcludeTask}
          // />
          <NewTaskV2
            idLead=""
            idLeadCorretor=""
            lead={null}
            dataLead={null}
            closeModal={() => setNewTask(false)}
            refetch={() => console.log("")}
          />
        }
        setOpenModal={setNewTask}
        open={newTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
      {/* <NewTaskModal
        setNewTask={setNewTask}
        idLead=""
        idLeadCorretor=""
        hotRefreshFunc={() => {
          requestTasks();
          requestTasksLate();
        }}
        showConclusion={showConclusion}
        setShowConclusion={setShowConclusion}
        className={`open-${newTask}`}
        nomeLead=""
        isHome
        isOpen={newTask}
      /> */}
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setEditTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Edição de tarefa"
        isFilter={false}
        isClose
        width={500}
        component={
          <EditTaskForm
            idLead={itemTask.idLead}
            idLeadCorretor={itemTask.idLeadCorretor}
            nomeLead={itemTask.nomeLead}
            itemTask={itemTask}
            onClose={setEditTask}
            open={editTask}
            hotRefreshFunc={() => {
              requestTasks();
              requestTasksLate(1);
            }}
          />
        }
        setOpenModal={setEditTask}
        open={editTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setConcludeTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Conclusão da tarefa"
        isFilter={false}
        isClose
        width={500}
        component={
          <ConcludeTaskForm
            idLead={itemTask.idLead}
            idLeadCorretor={itemTask.idLeadCorretor}
            itemConclude={itemConclude}
            nomeLead={itemTask.nomeLead}
            onClose={setConcludeTask}
            open={concludeTask}
            produto={itemConclude?.empreendimento}
            hotRefreshFunc={() => {
              requestTasks();
              setLateTasks([]);
              requestTasksLate(1);
            }}
          />
        }
        setOpenModal={setConcludeTask}
        open={concludeTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
    </Styles.SectionTasks>
  );
};
export default SectionTasks;
